import { ActionTypes, ContentTypes } from "../constants/action-types";
import { fromJS } from "immutable";
import { handleActions } from "redux-actions";

const getDefaultFilters = (contentType) => {
  const filters = [
    {
      name: "Grid view",
      data: {
        page: 0,
        pageSize: 50,
        filters: {},
        groupBy: "bucketId",
        groupByVisibleFieldIds: [],
        boardCardFields: [],
        gridFields: [],
        showCardLabels: false,
        fields: [],
        sorts: [],
        types: [contentType],
        view: "GRID",
      },
      visibility: "Shared",
    },
  ];
  if (contentType == ContentTypes.ACTIVITY) {
    filters.unshift({
      name: "Calendar view",
      data: {
        page: 0,
        pageSize: 50,
        filters: {},
        groupBy: "bucketId",
        groupByVisibleFieldIds: [],
        boardCardFields: [],
        gridFields: [],
        showCardLabels: false,
        fields: [],
        sorts: [],
        types: [contentType],
        view: "CALENDAR",
      },
      visibility: "Shared",
    });
  } else if (
    contentType == ContentTypes.SALE ||
    contentType == ContentTypes.CONTACT ||
    contentType == ContentTypes.COMPANY
  ) {
    filters.unshift({
      name: "Board view",
      data: {
        page: 0,
        pageSize: 50,
        filters: {},
        groupBy: "bucketId",
        groupByVisibleFieldIds: [],
        boardCardFields: [],
        gridFields: [],
        showCardLabels: false,
        fields: [],
        sorts: [],
        types: [contentType],
        view: "BOARD",
      },
      visibility: "Shared",
    });
  }
  return filters;
};

const initialState = fromJS({
  pending: true,
  myFilterLoading: true,
  myFilterList: [],
  myFilters: getDefaultFilters(ContentTypes.SALE),
  show: false,
  contentType: ContentTypes.SALE,

  currentFilter: "me",
  currentContactFilter: "",
  currentAccountFilter: "",
  currentActivityFilter: "",
});

export const buildUserFilterState = (state, payload) => {
  const {
    currentFilter = "me",
    currentContactFilter = "",
    currentAccountFilter = "",
    currentActivityFilter = "",
  } = payload;
  const newState = {
    ...state.toJS(),
    currentFilter,
    currentContactFilter,
    currentAccountFilter,
    currentActivityFilter,
    pending: false,
  };
  return fromJS(newState);
};

export const actions = {
  [ActionTypes.getMyFilters]: {
    next(state, data) {
      const { payload, error, pending } = data;
      if (error) {
        return state.merge({ error, pending, myFilterLoading: true });
      }
      if (pending) {
        return state.merge({ pending, myFilterLoading: true });
      }
      if (payload === null || payload == undefined) {
        return state;
      }
      const { filters = [], contentType } = payload;
      const newState = {
        ...state.toJS(),
        myFilters: [...getDefaultFilters(contentType), ...filters],
        myFilterLoading: false,
        contentType,
      };
      return fromJS(newState);
    },
  },
  [ActionTypes.getCurrentUser]: {
    next(state, data) {
      const { payload, error, pending } = data;
      if (error || payload == null) {
        return state.merge({ error, pending });
      }
      if (pending) {
        return state.merge({ pending });
      }
      return buildUserFilterState(state, payload);
    },
  },
  [ActionTypes.updateMyFilterSettings]: {
    next(state, data) {
      const { payload, error, pending } = data;
      if (error || payload === null) {
        return state.merge({ error, pending });
      }
      if (pending) {
        return state.merge({ pending });
      }
      return buildUserFilterState(state, payload);
    },
  },
};

export const filterReducer = handleActions(actions, initialState);
